import {
  GetLookupInfoRequest,
  LookupInfoByMatchType,
} from "@costar-search-x/core";
import { CoStar } from "@costar-gen/pds-node-client";
import { logClientError } from "@/components/common/hooks/log-client-error";
const MatchType = CoStar.Api.Lookup.MatchType;

const arr = <T>(arg: T[] | undefined) => arg ?? [];
const arrOfNumber = (arg: Array<number | string> | undefined) =>
  arr(arg).map((t) => Number(t));
const arrOfString = (arg: Array<number | string> | undefined) =>
  arr(arg).map((t) => String(t));

const arrToMap = <T extends { id: number | string; name: string }>(
  arr: T[] | undefined,
  idPrefix?: string
) => {
  if (arr) {
    return arr.reduce((res, { id, ...props }) => {
      if (idPrefix) {
        res[`${idPrefix}${id}`] = { ...props };
      } else {
        res[id] = { ...props };
      }
      return res;
    }, {} as { [index: number | string]: Omit<T, "id"> });
  }
};

const removeEmpty = <T extends { [index: number | string]: any }>(result: T) =>
  Object.keys(result).forEach((key) => {
    if (!result[key]) {
      delete result[key];
    }
  });

type MapMatchIdType = { [key: number]: string[] | number[] };

const fetchLookupInfo = async (request: GetLookupInfoRequest) => {
  const mapMatchTypeToIds: MapMatchIdType = {
    [MatchType.Company]: arrOfString(request[MatchType.Company]),
    [MatchType.Contact]: arrOfString(request[MatchType.Contact]),
    [MatchType.City]: arrOfNumber(request[MatchType.City]),
    [MatchType.Submarket]: arrOfNumber(request[MatchType.Submarket]),
    [MatchType.ResearchMarket]: arrOfNumber(request[MatchType.ResearchMarket]),
    [MatchType.County]: arrOfNumber(request[MatchType.County]),
    [MatchType.Subdivision]: arrOfNumber(request[MatchType.Subdivision]),
    [MatchType.Country]: arrOfNumber(request[MatchType.Country]),
    [MatchType.Region]: arrOfNumber(request[MatchType.Region]),
    [MatchType.StoreType]: arrOfNumber(request[MatchType.StoreType]),
    [MatchType.CoStarMarket]: arrOfNumber(request[MatchType.CoStarMarket]),
    [MatchType.PostalCodeGlobal]: arrOfNumber(
      request[MatchType.PostalCodeGlobal]
    ),
  };

  try {
    const res = await fetch("/api/directory/lookupInfo", {
      method: "POST",
      body: JSON.stringify({ mapMatchTypeToIds }),
    });

    const { data: result } = await res.json();

    const fetchLookupInfoResult: LookupInfoByMatchType = {};
    if (result) {
      for (const matchType in result) {
        if (result[matchType]) {
          fetchLookupInfoResult[parseInt(matchType)] = arrToMap(
            result[matchType]?.items
          ) as any;
        }
      }
    }

    removeEmpty(fetchLookupInfoResult);

    return fetchLookupInfoResult;
  } catch (error: any) {
    logClientError(error);
    return {};
  }
};

export { fetchLookupInfo };
